
import { FiChevronRight } from "react-icons/fi";
import { Link } from "react-router-dom";
import { useGetBlogCatQuery } from "../../products/productSlice";

import blog1 from "../../../assets/img/blog/1.jpg";
import blog2 from "../../../assets/img/blog/2.jpg";
import blog3 from "../../../assets/img/blog/3.jpg";


const cosmeticBlogCategories = [
  {
    id: 1,
    url: blog1,
    name: "Transform Your Outdoor Space: Expert Landscaping Tips & Ideas",
    description: "Your outdoor space is the first impression your home makes—so why not make it unforgettable? Landscaping isn’t just about planting a few flowers or mowing the lawn. It's about creating a cohesive, beautiful environment that enhances the look and feel of your property. Whether you're working with a sprawling backyard or a compact front garden, the right landscaping can completely transform your space."
  },
  {
    id: 2,
    url: blog2,
    name: "Landscaping Inspiration for Every Season",
    description: "Start by defining how you want to use your outdoor area. Do you envision a relaxing patio, a vibrant flower garden, or a space for entertaining guests? Planning with purpose helps guide your design choices, from selecting the right plants to choosing the best hardscape elements like walkways, decks, or retaining walls. Think of your yard as an extension of your home—it should reflect your personality and lifestyle."
  },
  {
    id: 3,    
    url: blog3,
    name: "Simple Landscaping Upgrades That Wow",
    description: "One of the most impactful ways to upgrade your landscaping is through layering and texture. Use a variety of plants—trees, shrubs, perennials, and ground covers—to create depth and visual interest. Incorporate stone, wood, or gravel elements for contrast, and don’t forget lighting! Well-placed outdoor lighting not only adds ambiance but also improves safety and functionality after dark."
  },
  {
    id: 4,
    url: blog1,
    name: "The Ultimate Guide to Modern Landscaping Design",
    description: "Finally, maintenance is key to long-term success. Choose plants suited to your climate and soil to reduce upkeep. Invest in a simple irrigation system to keep things green without extra effort. And remember: great landscaping doesn’t have to happen all at once. Start with small changes, and let your outdoor space evolve with your vision and budget."
  },
  
];

function BlogAside({ t }) {
  const { data, isLoading } = useGetBlogCatQuery();



  return (
    <>
      <div className="blogAsideSec">
        <div className="blogCategory">
          <h4 className="asideTitle">{t("Our Blog Category")}</h4>
          <hr />
          <ul>
            {isLoading && (
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            )}

            {/* {data &&
              data.map((item) => {
                return (
                  <li key={item._id}>
                    <Link to="/">
                      <FiChevronRight />
                      {item.name}
                    </Link>
                  </li>
                );
              })} */}

            {cosmeticBlogCategories.map((item) => {
              return (
                <li key={item.id}>
                  <Link to="/">
                    <FiChevronRight />
                    {item.name}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
        {/* <div className="recentPosts  ">
          <h4 className="asideTitle">recent posts</h4>
          <hr />
          <div className="recentItemInfo">
            <div className="recentImg">
              <img src={blog1} alt="Latest Blog" />
            </div>
            <div className="recentContent">
              <h6><Link to="/blog-detail">Top New Collection</Link></h6>
              <p className='date'>February 26, 2018</p>
            </div>
          </div>
          <div className="recentItemInfo  ">
            <div className="recentImg">
              <img src={blog2} alt="Latest Blog" />
            </div>
            <div className="recentContent">
              <h6><Link to="/blog-detail">Fashion Trends</Link></h6>
              <p className='date'>July 09, 2015</p>
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
}

export default BlogAside;
